import * as React from 'react';

import type { NegotiationClient } from '@/api/negotiation-client';
import { HttpNegotiationClient } from '@/api/negotiation-client.http';

// =============================================================================
// negotiation-client-context.tsx — Injection du NegotiationClient (DI seam).
// =============================================================================
// Permet de substituer le client sans toucher l'UI. Par défaut (S18) : l'adaptateur HTTP RÉEL
// (HttpNegotiationClient) — le câblage front↔back contre les surfaces gelées du stream B. Les tests de
// composant injectent le StubNegotiationClient (double déterministe) via le provider.

/** Adaptateur par défaut : HTTP réel (chemins relatifs racine API, cookie de session admin). */
const defaultNegotiationClient: NegotiationClient = new HttpNegotiationClient();

const NegotiationClientContext = React.createContext<NegotiationClient>(
  defaultNegotiationClient,
);

export interface NegotiationClientProviderProps {
  client?: NegotiationClient | undefined;
  children: React.ReactNode;
}

export function NegotiationClientProvider({
  client = defaultNegotiationClient,
  children,
}: NegotiationClientProviderProps): React.JSX.Element {
  return (
    <NegotiationClientContext.Provider value={client}>
      {children}
    </NegotiationClientContext.Provider>
  );
}

export function useNegotiationClient(): NegotiationClient {
  return React.useContext(NegotiationClientContext);
}
